module.exports = __webpack_public_path__ + "assets/img/00135.f5497ae8.png";